import {
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from "@/components/popover/Popover";

import type { AiNote } from "./utils/aiRelevance";

interface AiNotePopoverProps {
  note: AiNote;
  /** Feltets label — gør knappen entydig for skærmlæsere. */
  fieldLabel: string;
}

/**
 * AI'ens begrundelse bag et lille "AI"-mærke ved feltets label.
 *
 * Åbnes ved klik, ikke hover: begrundelsen er flere linjer, som skal kunne
 * læses i ro, og en klik-popover kan også åbnes med tastatur og touch.
 * Skrivebeskyttet — det er grundlaget for en rettelse, ikke noget, der rettes.
 */
export const AiNotePopover = ({ note, fieldLabel }: AiNotePopoverProps) => (
  <PopoverRoot>
    <PopoverTrigger asChild>
      <button
        aria-label={`Vis AI'ens begrundelse for ${fieldLabel}`}
        className="c-ai-note-trigger"
        title="Vis AI'ens begrundelse"
        type="button"
      >
        AI
      </button>
    </PopoverTrigger>
    <PopoverContent align="start" className="c-ai-note-content small">
      {note.title && <strong>AI: {note.title}</strong>}
      {note.body && <p className="mb-0">{note.body}</p>}
    </PopoverContent>
  </PopoverRoot>
);
